import { useLoyalty } from "../../context";
import { useStore } from "../../hooks";
import { OrderModel } from "../../models";
import { formatCurrency } from "../../utilities";

type Props = {
  order: OrderModel;
};

const OrderLoyalty: React.FC<Props> = ({ order }) => {
  const { loyaltyAmount } = useLoyalty();
  const { storeLocations } = useStore();

  if (!order?.loyalty?.points) return <></>;

  return (
    <div className="loyalty-card">
      <div className="loyalty-logoo mx-auto mb-3" style={{ width: "100px" }}>
        <img src={storeLocations?.store_logo} alt="Logo" />
      </div>
      <div className="loyalty-content p-0">
        <h2>
          You earned {order?.loyalty?.points || 0} points from this order.
        </h2>
        {Number(loyaltyAmount) > 0 && (
          <p>
            Total balance{" "}
            <span className="balance">
              {formatCurrency(Number(loyaltyAmount))}
            </span>
          </p>
        )}
      </div>
    </div>
  );
};

export default OrderLoyalty;
